module.exports = __webpack_public_path__ + "img/not_found (3).4bc1d6ac.jpg";